import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/sharp-solid-svg-icons/faMagnifyingGlass';

export const InputSearchIcon = ({ className = '' }) => <FontAwesomeIcon className={className} icon={faMagnifyingGlass} />;
